import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab } from 'react-bootstrap';
import { EarningAndCommitmentComponent } from './EarningAndCommitmentComponent';
import { EssentialSpendingsComponent } from './EssentialSpendingsComponent';
import AlertsNotificationsComponent from './AlertsNotificationsComponent';
import FinancialStoriesModal from '../tag/FinancialStoriesModal';
import { BasicModal } from '../../common/modals/BasicModal';
import LoaderComponent from '../../common/LoaderComponent';

function getStateFromStores() {
  return {
    value: null,
    dLeaveSetup: false,
  };
}

/**
 * @todo
 * The quality of this component may be improved in future improvement efforts.
 */
class ProjectionSettings extends Component {
  constructor(props) {
    super(props);

    this.handleSelect = this.handleSelect.bind(this);

    this.state = getStateFromStores();
  }

  handleSelect() {
    this.props.resetshakeamountvalue();
  }

  render() {
    let errMessage;
    let qId;
    if (this.props.putProjectionMessage !== undefined) {
      if (this.props.putProjectionMessage.error !== undefined) {
        if (this.props.putProjectionMessage.error.quoteId !== undefined) {
          qId = this.props.putProjectionMessage.error.quoteId;
        } else {
          qId = 'a12bC23';
        }

        if (this.props.putProjectionMessage.error.message !== undefined) {
          errMessage = this.props.putProjectionMessage.error.message;
        } else {
          errMessage = 'Something went wrong';
        }
      }
    }
    if (
      this.props.earningsAndCommitmentsData === undefined ||
      Object.keys(this.props.earningsAndCommitmentsData).length === 0 ||
      this.props.activityIndicator
    ) {
      return <LoaderComponent type="large" />;
    } else {
      return (
        <div className="settings-main-wrapper">
          <div className="col-xs-6">
            {this.props.cancelButtonFlag ? (
              <p>
                <a
                  href="javascript:void(0)"
                  onClick={this.props._cancel_button}
                >
                  {this.props.content.projectionSettingsCancelButton}
                </a>
              </p>
            ) : (
              <button
                className="page-back white"
                onClick={this.props.doneClicked}
              >
                <span className="icon icon-page-back" />
                Back
              </button>
            )}
          </div>
          <div className="col-xs-6">
            {this.props.cancelButtonFlag ? (
              <div className="settings">
                <a
                  href="javascript:void(0)"
                  onClick={this.props._opt_out_of_projections}
                >
                  <span className="icon icon-opt-out" />
                  {this.props.content.projectionSettingsOptOutOfProjection}
                </a>
              </div>
            ) : (
              ''
            )}
          </div>
          <div className="clear" />
          <div className="setting-nav">
            <Tabs
              activeKey={this.state.key}
              onSelect={this.handleSelect}
              id="controlled-tab-example"
              bsStyle="pills"
            >
              <Tab
                eventKey={1}
                title={
                  this.props.content.projectionSettingsEarningsAndCommitments
                }
              >
                <EarningAndCommitmentComponent
                  data={this.props.earningsAndCommitmentsData}
                  getEarningsId={this.props.getEarningsId}
                  content={this.props.content}
                />
              </Tab>
              <Tab
                eventKey={2}
                title={this.props.content.projectionSettingsEssentialSpending}
              >
                <EssentialSpendingsComponent
                  data={this.props.earningsAndCommitmentsData}
                  selectTag={this.selectTag}
                  modifiedUserTag={this.props.modifiedUserTag}
                  modifiedTags={this.props.modifiedTags}
                  content={this.props.content}
                />
              </Tab>
              <Tab
                eventKey={3}
                title={
                  this.props.content.projectionSettingsAlertsAndNotifications
                }
              >
                <AlertsNotificationsComponent
                  alertsAmountValue={this.props.alertsAmountValue}
                  changeTheValue={this.props.changeTheValue}
                  notificationFlag={this.props.notificationFlag}
                  notificationAlert={this.props.notificationAlert}
                  changeTheNotificationFlag={
                    this.props.changeTheNotificationFlag
                  }
                  content={this.props.content}
                  selectDropdown={this.props.selectDropdown}
                  shakeamount={this.props.shakeamount}
                  dropdownSelection={this.props.dropdownSelection}
                  dropDownFlag={this.props.dropDownFlag}
                  shakeamountZero={this.props.shakeamountZero}
                  selectedValue={this.props.selectedValue}
                  shakeFalse={this.props.shakeFalse}
                />
              </Tab>
            </Tabs>
            <div className="clear" />
          </div>
          {this.props.optOutFlag ? (
            <FinancialStoriesModal
              header={
                this.props.content.projectionOptOutOfProjectionsPopupHeader
              }
              content={
                this.props.content.projectionOptOutOfProjectionsPopupContent
              }
              confirmCancel={this.props.optOutFlag}
              yesButton
              cancelButton
              cancelText={
                this.props.content
                  .projectionLeaveProjectionsSetupPopupCancelButton
              }
              onClickDeleteTag={this.props.onclickCancelForOptOut}
              yesText={
                this.props.content
                  .projectionOptOutOfProjectionsPopupOptOutButton
              }
            />
          ) : null}
          {this.props.cancelFlag ? (
            <FinancialStoriesModal
              header={
                this.props.content.projectionLeaveProjectionsSetupPopupHeader
              }
              content={
                this.props.content.projectionLeaveProjectionsSetupPopupContent
              }
              confirmCancel={this.props.cancelFlag}
              yesButton
              cancelButton
              cancelText={
                this.props.content
                  .projectionLeaveProjectionsSetupPopupCancelButton
              }
              onClickDeleteTag={this.props.onclickLeaveSetup}
              yesText={
                this.props.content
                  .projectionLeaveProjectionsSetupPopupLeaveSetupButton
              }
            />
          ) : null}
          {this.props.dLeaveSetup ? (
            <FinancialStoriesModal
              header={
                this.props.content.projectionLeaveProjectionsSetupPopupHeader
              }
              content={
                this.props.content.projectionLeaveProjectionsSetupPopupContent
              }
              confirmCancel={this.props.dLeaveSetup}
              yesButton
              cancelButton
              cancelText={
                this.props.content
                  .projectionLeaveProjectionsSetupPopupCancelButton
              }
              onClickDeleteTag={this.props.optoutDemo}
              yesText={
                this.props.content
                  .projectionLeaveProjectionsSetupPopupLeaveSetupButton
              }
            />
          ) : null}
          {this.props.putProjectionPreferenceErrorHandlingFlag ? (
            <FinancialStoriesModal
              header={qId}
              content={errMessage}
              confirmCancel={
                this.props.putProjectionPreferenceErrorHandlingFlag
              }
              cancelButton
              cancelText="Ok"
              onClickDeleteTag={this.props.clearPopupForPutProjectionsError}
            />
          ) : (
            ''
          )}
          {this.props.crunch ? (
            <BasicModal>
              <div className="modalb msg-popup single-msg">
                <div className="modalb-contanier">
                  <h3>{this.props.content.projectedCrunchingHeader1}</h3>
                  <p>{this.props.content.projectedCrunchingHeader2}</p>
                </div>
                <div className="modalb-footer">
                  <button
                    className="c-btn c-btn--default"
                    onClick={this.props.popupBack}
                  >
                    {this.props.content.ok}
                  </button>
                </div>
              </div>
            </BasicModal>
          ) : null}
          <button
            className="action-button white"
            onClick={this.props.doneProjectionSettings}
          >
            {this.props.content.projectionSettingsDoneButton}
          </button>
        </div>
      );
    }
  }
}

ProjectionSettings.propTypes = {
  cancelButtonFlag: PropTypes.bool,
  _cancel_button: PropTypes.func,
  onLoad: PropTypes.bool,
  content: PropTypes.object,
  doneClicked: PropTypes.func,
  _opt_out_of_projections: PropTypes.func,
  earningsAndCommitmentsData: PropTypes.object,
  getEarningsId: PropTypes.func,
  modifiedTags: PropTypes.func,
  modifiedUserTag: PropTypes.func,
  alertsAmountValue: PropTypes.func,
  changeTheValue: PropTypes.func,
  notificationFlag: PropTypes.bool,
  notificationAlert: PropTypes.bool,
  changeTheNotificationFlag: PropTypes.func,
  optOutFlag: PropTypes.bool,
  cancelFlag: PropTypes.bool,
  dLeaveSetup: PropTypes.bool,
  onclickCancelForOptOut: PropTypes.func,
  onclickLeaveSetup: PropTypes.func,
  optoutDemo: PropTypes.func,
  doneProjectionSettings: PropTypes.func,
  dropdownSelection: PropTypes.func,
  dropDownFlag: PropTypes.bool,
  selectDropdown: PropTypes.func,
  shakeamount: PropTypes.bool,
  shakeFalse: PropTypes.func,
  putProjectionPreferenceErrorHandlingFlag: PropTypes.bool,
  putProjectionMessage: PropTypes.object,
  clearPopupForPutProjectionsError: PropTypes.func,
};

export { ProjectionSettings };
